export default __webpack_public_path__ + "static/media/big_robot_and_console.344ba9ab.jpg";